export const profits = {
  'backoffice.profits.accountsSummary.title': 'Accounts Profit Summary',
  'backoffice.profits.accountsSummary.subtitle': 'Overview of profit performance across all your investment accounts',
  'backoffice.profits.accountsHistory.title': 'Accounts Profit History',
  'backoffice.profits.accountsHistory.subtitle': 'Detailed historical profit data for your investment accounts',
  'backoffice.profits.commissionsSummary.title': 'Commissions Summary',
  'backoffice.profits.commissionsSummary.subtitle': 'Overview of your referral commissions and earnings',
  'backoffice.profits.commissionsHistory.title': 'Commissions History',
  'backoffice.profits.commissionsHistory.subtitle': 'Detailed history of commission earnings and transactions',
  'backoffice.profits.commissionsPaymentHistory.title': 'Commission Payment History',
  'backoffice.profits.commissionsPaymentHistory.subtitle': 'Track all commission payments and withdrawal history',
  'backoffice.profits.common.loading': 'Loading profit data...',
  'backoffice.profits.common.error': 'Error loading profit information',
  'backoffice.profits.common.noData': 'No profit data available',
  'backoffice.profits.common.comingSoon': 'This feature is coming soon',
  'backoffice.profits.common.placeholder': 'Profit details will be displayed here once implemented',
  'backoffice.profits.lifetime.title': 'Accounts Profit Lifetime',
  'backoffice.profits.lifetime.totalProfit': 'Total Lifetime Profit',
  'backoffice.profits.lifetime.accountProfit': 'Account Profit',
  'backoffice.profits.lifetime.programProfit': 'Program Profit',
  'backoffice.profits.lastMonth.title': 'Accounts Profit Last Month',
  'backoffice.profits.lastMonth.totalProfit': 'Total Last Month Profit',
  'backoffice.profits.lastMonth.accountProfit': 'Account Profit',
  'backoffice.profits.lastMonth.programProfit': 'Program Profit',
  'backoffice.profits.overtime.title': 'Accounts Profit Over Time',
  'backoffice.profits.overtime.chartTitle': 'Profit History (Last 12 Months)',
  'backoffice.profits.breakdown.title': 'Breakdown by Account',
  'backoffice.profits.breakdown.accountNumber': 'Account Number',
  'backoffice.profits.breakdown.broker': 'Broker',
  'backoffice.profits.breakdown.balance': 'Balance',
  'backoffice.profits.breakdown.accountProfit': 'Account Profit',
  'backoffice.profits.breakdown.programProfit': 'Program Profit',
  'backoffice.profits.breakdown.totalProfit': 'Total Profit',
  'backoffice.profits.breakdown.noAccounts': 'No accounts found',
  'backoffice.profits.history.filters.account': 'Account',
  'backoffice.profits.history.filters.allAccounts': 'All Accounts',
  'backoffice.profits.history.filters.dateFrom': 'From Date',
  'backoffice.profits.history.filters.dateTo': 'To Date',
  'backoffice.profits.history.filters.apply': 'Apply Filters',
  'backoffice.profits.history.filters.reset': 'Reset',
  'backoffice.profits.history.table.title': 'Profit History',
  'backoffice.profits.history.table.account': 'Account',
  'backoffice.profits.history.table.period': 'Period',
  'backoffice.profits.history.table.accountProfit': 'Account Profit',
  'backoffice.profits.history.table.exportCSV': 'Export CSV',
  'backoffice.profits.history.pagination.showing': 'Showing',
  'backoffice.profits.history.pagination.of': 'of',
  'backoffice.profits.history.pagination.results': 'results',
  'backoffice.profits.history.pagination.page': 'Page',
  'backoffice.profits.history.pagination.previous': 'Previous',
  'backoffice.profits.history.pagination.next': 'Next',
  'backoffice.profits.history.pagination.loadMore': 'Load More',
  'backoffice.profits.commissions.lifetime.title': 'Lifetime Commissions',
  'backoffice.profits.commissions.lastMonth.title': 'Last Month Commissions',
  'backoffice.profits.commissions.balance.title': 'Current Balance',
  'backoffice.profits.commissions.balance.lastUpdated': 'Last updated:',
  'backoffice.profits.commissions.paid.title': 'Total Paid',
  'backoffice.profits.commissions.overtime.title': 'Commissions Over Time',
  'backoffice.profits.commissionsHistory.filters.level': 'Level',
  'backoffice.profits.commissionsHistory.filters.allLevels': 'All Levels',
  'backoffice.profits.commissionsHistory.filters.levelNumber': 'Level {{level}}',
  'backoffice.profits.commissionsHistory.table.title': 'Commission History',
  'backoffice.profits.commissionsHistory.table.date': 'Date',
  'backoffice.profits.commissionsHistory.table.level': 'Level',
  'backoffice.profits.commissionsHistory.table.levelCompany': 'Company',
  'backoffice.profits.commissionsHistory.table.levelLeftover': 'Leftover',
  'backoffice.profits.commissionsHistory.table.commission': 'Commission',
  'backoffice.profits.commissionsHistory.table.levelNumber': 'Level {{level}}',
  'backoffice.profits.commissionsPaymentHistory.filters.status': 'Status',
  'backoffice.profits.commissionsPaymentHistory.filters.allStatuses': 'All Statuses',
  'backoffice.profits.commissionsPaymentHistory.filters.paymentMethod': 'Payment Method',
  'backoffice.profits.commissionsPaymentHistory.filters.allPaymentMethods': 'All Payment Methods',
  'backoffice.profits.commissionsPaymentHistory.filters.crypto': 'Crypto',
  'backoffice.profits.commissionsPaymentHistory.filters.bank': 'Bank Transfer',
  'backoffice.profits.commissionsPaymentHistory.table.title': 'Commission Payment History',
  'backoffice.profits.commissionsPaymentHistory.table.date': 'Date',
  'backoffice.profits.commissionsPaymentHistory.table.paymentMethod': 'Payment Method',
  'backoffice.profits.commissionsPaymentHistory.table.status': 'Status',
  'backoffice.profits.commissionsPaymentHistory.table.amount': 'Amount',
  'backoffice.profits.commissionsPaymentHistory.table.exportCSV': 'Export CSV',
  'backoffice.profits.commissionsPaymentHistory.status.paid': 'Paid',
  'backoffice.profits.commissionsPaymentHistory.status.completed': 'Completed',
  'backoffice.profits.commissionsPaymentHistory.status.pending': 'Pending',
  'backoffice.profits.commissionsPaymentHistory.status.cancelled': 'Cancelled',
  'backoffice.profits.commissionsPaymentHistory.status.failed': 'Failed',
  'backoffice.profits.commissionsPaymentHistory.status.rejected': 'Rejected',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.crypto': 'Crypto',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.bank': 'Bank Transfer',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.unknown': 'Unknown'
};
